import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NewsGrid.module.css';

const NewsGrid = ({ lang }) => {
  const content = {
    EN: {
      heading: "Latest Trending Updates",
      news: [
        { id: 8, title: "Sheikh Hamad: How an Arab Leader Broke the Blockade on Gaza", desc: " Sheikh Hamad: The Leader Who Defied the Siege on Gaza...", image: "Hamad1.jpeg" },
        { id: 9, title: "FIFA World Cup 2026: The Race for Glory", desc: "Are Messi, Mbappe, Yamal, Kane in the best semifinals yet?...", image: "/Fifa2.jpeg" },
        { id: 10, title: "Pakistan takes centre stage as OIC Women’s Summit opens to advance empowerment agenda", desc: "Pakistan hosts the 9th OIC Ministerial Conference on Women in Islamabad, aiming to advance women’s socio-economic and political empowerment. The two-day event will end with the Islamabad Declaration....", image: "/OIC5.jpeg" },
        { id: 11, title: " New Iran strikes on Gulf as US attacks escalate: What we know", desc: "Iran targets its Gulf neighbours in third round of tit-for-tat attacks with US in a week....", image: "/Attack3.jpeg" },
        { id: 12, title: "Are Messi, Mbappe, Yamal, Kane in the best semifinals yet?", desc: "France, Spain, England and Argentina have the stars for the semifinals, but will the performances match the reputations?...", image: "/Player2.jpeg" }
      ]
    },
    UR: {
      heading: "تازہ ترین ٹرینڈنگ اپڈیٹس",
      news: [
        { id: 8, title: "شیخ حمد: غزہ کے محاصرے کو چیلنج کرنے والے عرب رہنما", desc: "شیخ حمد: وہ عرب لیڈر جس نے غزہ کی ناکہ بندی ختم کی...", image: "/Hamad1.jpeg" },
        { id: 9, title: "فیفا ورلڈ کپ 2026 اب اپنے آخری اور فیصلہ کن مراحل میں داخل ہو چکا ہے، جہاں دنیا کی چار بڑی ٹیمیں ٹائٹل کے حصول کے لیے آمنے سامنے ہیں۔", desc: "...", image: "/Fifa2.jpeg" },
        { id: 10, title: "خواتین کو بااختیار بنانے کے ایجنڈے کو آگے بڑھانے کے لیے او آئی سی (OIC) ویمن سمٹ کے آغاز پر پاکستان مرکزی حیثیت اختیار کر گیا۔", desc: "پاکستان اسلام آباد میں خواتین پر او آئی سی (OIC) کی نویں وزارتی کانفرنس کی میزبانی کر رہا ہے، جس کا مقصد خواتین کو سماجی، اقتصادی اور سیاسی طور پر بااختیار بنانا ہے۔ دو روزہ تقریب کا اختتام 'اسلام آباد اعلامیہ' پر ہوگا۔...", image: "/OIC5.jpeg" },
        { id: 11, title: "خلیج میں ایران کے نئے حملے، جبکہ امریکہ کے حملوں میں تیزی: ہم کیا جانتے ہیں؟", desc: "ایران نے ایک ہفتے کے اندر امریکہ کے ساتھ ہونے والے جوابی حملوں کے تیسرے مرحلے میں اپنے خلیجی پڑوسیوں کو نشانہ بنایا۔...", image: "/Attack3.jpeg" },
        { id: 12, title: "کیا میسی، مباپے، یامال اور کین اب تک کے بہترین سیمی فائنلز میں شامل ہیں؟", desc: "فرانس، اسپین، انگلینڈ اور ارجنٹائن کے پاس سیمی فائنل کے لیے بڑے کھلاڑی تو موجود ہیں، لیکن کیا ان کی کارکردگی ان کی ساکھ کے مطابق ہوگی؟..", image: "/Player2.jpeg" }
      ]
    }
  };

  const t = content[lang] || content['EN'];

  return (
    <section className={styles.gridSection}>
      <h2 className={styles.sectionHeading}>{t.heading}</h2>
      <div className={styles.newsList}>
        {t.news.map((item) => (
          <Link to={`/news/${item.id}`} key={item.id} className={styles.newsLink}>
            <div className={styles.newsItem}>
              {/* Yahan image ka path dynamic ho gaya hai */}
              <img src={item.image} alt={item.title} />
              <div className={styles.newsContent}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default NewsGrid;